import React from 'react';
import View from './view';
import {useSelector} from 'react-redux';
import {privilegesSelector} from '../../redux/selectors/privilege';

export const PrivilegesScreen = () => {
  const privileges = useSelector(privilegesSelector());

  return <View privileges={privileges} />;
};
